import React, { Component } from 'react'
import styled from 'styled-components'
import { media } from 'styled-bootstrap-grid'

const Wrapper = styled.div`
  position: absolute;
  bottom: 2rem;
  left: 2rem;
  z-index: 2;

  ${media.xs`
    bottom: 1rem;
    left: 1rem;
    transform: scale(0.8);
  `}
`

export default class Icon9 extends Component {
  render() {
    return(
      <Wrapper>
        <svg
          width="49"
          height="87"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill="#FFF"
            fillRule="evenodd"
            d="M.5078125 29.453125v-4.5703125c0-8.0859779 2.2656023-14.0917772 6.796875-18.0175781C11.8359602 2.9394335 17.5390281.9765625 24.4140625.9765625c6.796909 0 12.4706804 2.0019331 17.0214844 6.0058594 4.5508041 4.0039262 6.8261721 9.9316013 6.8261721 17.7832031v39.0234375c0 7.2656613-2.294899 12.8613085-6.8847659 16.78710938-4.5898667 3.92580087-10.244107 5.88867187-16.9628906 5.88867187-7.1875359 0-12.6464657-1.70896729-16.3769531-5.12695313C4.306622 77.91990479 2.2070336 72.6562855 1.7382812 65.546875h4.8046876c.7812539 11.13286816 6.8163498 16.69921875 18.1054687 16.69921875 5.1953385 0 9.6093568-1.66013965 13.2421875-4.98046875 3.6328307-3.3203291 5.4492188-7.910127 5.4492188-13.7695312V43.6914062c-3.7500188 6.4062821-10.25386 9.609375-19.5117188 9.609375-6.796909 0-12.3827906-1.9531054-16.7578125-5.8593749-4.3750219-3.9062696-6.5625-9.9023034-6.5625-17.9882813zm4.8046875 0c0 6.5625328 1.8163881 11.4843586 5.4492188 14.765625 3.6328306 3.2812664 8.1835664 4.921875 13.6523437 4.921875 5.9375297 0 10.5761552-1.5624844 13.9160156-4.6875 3.3398605-3.1250156 5.0097657-7.9687172 5.0097657-14.53125V25c0-6.4844074-1.8749813-11.4062332-5.625-14.765625-3.7500188-3.3593918-8.1835682-5.0390625-13.3007813-5.0390625-5.4297146 0-9.9706849 1.6015465-13.6230469 4.8046875S5.3125 18.1640289 5.3125 24.8828125v4.5703125z"
          />
        </svg>
      </Wrapper>
    )
  }
}



// WEBPACK FOOTER //
// ./src/ui/components/modules/Grades/Icon9.js